module.exports = __webpack_public_path__ + "static/img/tabbt2022.0c779e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tabbt2022.png
// module id = 7zZK
// module chunks = 1